import React, { useEffect } from 'react';
import { toastr } from 'react-redux-toastr';
import Toggle from '../../Elements/Toggle';

// import { Container } from './styles';

export default (props) => {
  const { toggleIa, item, bot, user } = props;

  const handleToggleIa = () => {
    if (bot.iaEnabled === false) {
      toastr.warning('Para utilizar este recurso é necessário ativar a IA.');
    }

    toggleIa();
  };

  return (
    <>
      <Toggle
        disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
        checked={item.useIA || false}
        onChange={() => {
          handleToggleIa();
        }}
      />
      <label>Inteligência Artificial</label>
    </>
  );
};
